/**
 * Stato condiviso delle voci degli hub «Configurazione» e «Configurazione Admin» (vedi useHubVoci). Sta in un
 * modulo a parte, senza dipendenze, così lo store auth può azzerarlo al logout senza import circolari.
 */
import { ref } from 'vue'
import type { ConfigurazioneVoce } from '@/modules/configurazione/composables/useConfigurazioneHub'

export const hubVoci = ref<ConfigurazioneVoce[]>([])
export const hubStato: { caricatoPer: number | null; richiesta: number } = { caricatoPer: null, richiesta: 0 }

/** Hub Admin: stato gemello e indipendente (un fallimento dell'uno non svuota l'altro). */
export const hubVociAdmin = ref<ConfigurazioneVoce[]>([])
export const hubStatoAdmin: { caricatoPer: number | null; richiesta: number } = { caricatoPer: null, richiesta: 0 }

/** Si incrementa a ogni azzeramento: chi osserva ricarica gli hub (breadcrumb, menu attivo e palette non restano vuoti). */
export const hubInvalidazioni = ref(0)

/** Svuota le voci, dimentica per chi erano e invalida ogni richiesta ancora in volo (entrambi gli hub). */
export function azzeraHubVoci(): void {
  hubVoci.value = []
  hubStato.caricatoPer = null
  hubStato.richiesta++
  hubVociAdmin.value = []
  hubStatoAdmin.caricatoPer = null
  hubStatoAdmin.richiesta++
  hubInvalidazioni.value++
}
